import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import FarmersPulseRoutes from "../routes";
import FarmersStandaloneHeader from "./Header";
import FarmersStandaloneFooter from "./Footer";

/**
 * FarmersStandaloneApp
 *
 * Root React app for farmerspulse.com. Wraps the docket with a
 * cream/forest-green shell (Header + Footer) and mounts every docket
 * route at root URLs — `/` renders the marketing home hero, `/today`
 * the dashboard, `/billing` the plans page, etc.
 *
 * Bootstrapped by `frontend/src/index.js` when
 * `REACT_APP_FARMERSPULSE_STANDALONE === "true"`.
 */
export default function FarmersStandaloneApp() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div
          className="min-h-screen"
          style={{
            // Farmers Pulse standalone palette — forest green + cream.
            // These CSS variables are read by FarmersNav, module cards,
            // hero components, etc.
            "--np-brand": "#2D8659",
            "--np-bg":    "#F8F4E9",
            "--np-live":  "#0F3D2A",
            "--np-meta":  "#3E4A3F",
            backgroundColor: "#F8F4E9",
          }}
        >
          <FarmersStandaloneHeader />
          <main className="pt-20 md:pt-24">
            <Routes>{FarmersPulseRoutes({ standalone: true })}</Routes>
          </main>
          <FarmersStandaloneFooter />
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
